import React, { useState, useRef } from 'react';
import '../styles/TagChipInput.css';

const dedupeCaseInsensitive = (existing, candidate) => {
    const trimmed = candidate.trim();
    if (!trimmed) return null;
    const lc = trimmed.toLowerCase();
    if (existing.some(t => t.toLowerCase() === lc)) return null;
    return trimmed;
};

function TagChipInput({ value, onChange, placeholder, disabled, label, id }) {
    const tags = Array.isArray(value) ? value : [];
    const [draft, setDraft] = useState('');
    const inputRef = useRef(null);

    const commitDraft = (raw) => {
        const next = dedupeCaseInsensitive(tags, raw);
        if (next == null) {
            setDraft('');
            return;
        }
        onChange([...tags, next]);
        setDraft('');
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            commitDraft(draft);
        } else if (e.key === 'Backspace' && draft === '' && tags.length > 0) {
            onChange(tags.slice(0, -1));
        }
    };

    const handleBlur = () => {
        if (draft.trim()) commitDraft(draft);
    };

    const removeTag = (idx) => {
        const next = tags.slice();
        next.splice(idx, 1);
        onChange(next);
        if (inputRef.current) inputRef.current.focus();
    };

    return (
        <div className="tag-chip-input-wrapper">
            {label ? <label htmlFor={id} className="body-semibold colour-primary tag-chip-input-label">{label}</label> : null}
            <div
                className={`tag-chip-input-container${disabled ? ' tag-chip-input-disabled' : ''}`}
                onClick={() => inputRef.current?.focus()}
            >
                {tags.map((tag, idx) => (
                    <span key={`${tag}-${idx}`} className="tag-chip body-regular">
                        <span className="tag-chip-text">{tag}</span>
                        <button
                            type="button"
                            className="tag-chip-remove"
                            onClick={(e) => { e.stopPropagation(); removeTag(idx); }}
                            disabled={disabled}
                            aria-label={`Remove ${tag}`}
                        >
                            ×
                        </button>
                    </span>
                ))}
                <input
                    ref={inputRef}
                    id={id}
                    type="text"
                    className="tag-chip-input body-regular"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={handleBlur}
                    placeholder={tags.length === 0 ? (placeholder || 'Add tags…') : ''}
                    disabled={disabled}
                />
            </div>
        </div>
    );
}

export default TagChipInput;
